<template>
  <el-dropdown
    class="language-container"
    @command="changeLanguage"
    id="languageDropdown"
  >
    <div class="language-wrapper">
      <span class="user-name">{{ showLanguage.name }}</span>
      <i style="margin-left: 8px" class="el-icon-caret-bottom" />
    </div>
    <el-dropdown-menu
      :append-to-body="false"
      slot="dropdown"
      class="language-dropdown"
    >
      <el-dropdown-item
        v-for="(lang, index) in languageOption"
        :key="index"
        :id="lang.code"
        :command="lang.code"
      >
        <span class="dropText">{{ lang.name }}</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { initState as globalState } from "@/store/shardActions";

export default {
  computed: {
    languageOption() {
      return this.$store.state.config.languageList;
    },
    showLanguage: {
      get() {
        let lang = globalState.currentLanguage;
        let showLanguageObj = this.languageOption.find(
          (item) => item.code == lang
        );
        let showLanguage = this.languageOption.find(
          (item) => item.code == "en"
        );
        if (showLanguageObj) {
          showLanguage = showLanguageObj;
        }
        this.$i18n.locale = showLanguage.code;
        this.$actions.setGlobalState({
          currentLanguage: showLanguage.code,
        });
        return showLanguage;
      },
      set(val) {
        this.$i18n.locale = val;
      },
    },
  },
  methods: {
    changeLanguage(lang) {
      this.$actions.setGlobalState({
        currentLanguage: lang,
      });
      this.showLanguage = lang;
    },
  },
};
</script>

<style lang="scss" scoped>
.language-container {
  cursor: pointer;
  margin-right: 20px;
  display: flex;
  align-items: center;

  .language-dropdown {
    li {
      white-space: nowrap;
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
